<template>
  <div class="bag">
    <div class="bag-inner">
      <h5 class="title" v-if="title">{{ title }}</h5>
      <slot name="list"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "列表为空～",
    },
    isSchoolBased: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped lang="scss">
.bag {
  position: absolute;
  left: 104%;
  top: 0;
  z-index: 100;
  width: 800px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  &:before {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 20px;
    left: -12px;
    border-right-color: #fff;
    content: " ";
    border-width: 6px;
  }
  .bag-inner {
    padding: 65px 12px 4px;
    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding: 25px 0;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      color: #333;
      line-height: 16px;
    }
  }
}
</style>
